'use client';

import { ELocalStorageKeys, ESessionStorageKeys } from '@web-store-platforms/types';
import { BaseWebStorageService } from '@web-store-platforms/storage';
import { LoggerEventNames } from '../consts/logger';
import coralogixRumService from '../services/coralogixRum';

class StoreWebStorageService extends BaseWebStorageService {
    private static readonly PERSISTENT_KEYS: Set<string> = new Set([
        ELocalStorageKeys.ANALYTICS_CONSENT,
        ELocalStorageKeys.CURRENT_LANGUAGE,
        ELocalStorageKeys.MOCK_BOOT_API,
        ELocalStorageKeys.MOCK_OFFERS_API,
        ELocalStorageKeys.MOCK_TEMPLATE_API,
    ]);
    private static readonly PERSISTENT_SESSION_KEYS: Set<string> = new Set([
        ESessionStorageKeys.UTM_PARAMS,
    ]);

    constructor() {
        super({
            onError: (_key, error) => {
                coralogixRumService.sendErrorEvent(LoggerEventNames.STORAGE_ERROR, {
                    message: 'Failed to read from storage',
                    error,
                });
            },
        });
    }

    getSessionStorageWithFallback = (): { id: string; ttl: number } | null => {
        return this.getStorageWithFallback();
    };

    clear = (): void => {
        if (!this.isClient) return;

        this.sessionStorageKeys.forEach((key) => {
            if (!StoreWebStorageService.PERSISTENT_SESSION_KEYS.has(key)) {
                this.remove(key as ESessionStorageKeys);
            }
        });

        this.localStorageKeys.forEach((key) => {
            if (!StoreWebStorageService.PERSISTENT_KEYS.has(key)) {
                this.remove(key as ELocalStorageKeys);
            }
        });
    };
}

export const webStorageUtil = new StoreWebStorageService();
